
/*
  This file is auto-generated by generate-icon-components.js. Do not edit it manually.
*/
import { html, css, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";

export const FhiIconMapPinSelector = "fhi-icon-map-pin";

/**
 * ## FhiIconMapPin
 * 
 * {@link https://designsystem.fhi.no/?path=/docs/ikoner--docs}
 * 
 * @tag fhi-icon-map-pin
 * @element fhi-icon-map-pin
 */
@customElement(FhiIconMapPinSelector)
export class FhiIconMapPin extends LitElement {

  /**
   * Sets the color for the icon.
   * Should preferably be a color token. See [Color Tokens](https://designsystem.fhi.no/?path=/docs/design-tokens-farger--docs)
   * @type {string}
   */ 
  @property({ type: String }) color: string = "currentcolor";

  /**
   * Sets the size of the icon. Can be one of the predefined sizes, a number value, rem or px.
   * Number values are treated as px.
   * @type { 'xsmall' | 'small' | 'medium' | 'large' | number | string}
   */
  @property({ type: String }) size: 'xsmall' | 'small' | 'medium' | 'large' | number | `${number}px` | `${number}rem` = 'medium';

  private get _size(): string {
    switch (this.size) {
      case 'xsmall': 
        return '1rem'; 
      case 'small':
        return '1.25rem';
      case 'medium':
        return '1.5rem'; 
      case 'large':
        return '2rem'; 
      default:
        if (String(this.size).endsWith('px') || String(this.size).endsWith('rem')) {
          return String(this.size);
        }
        if (isNaN(Number(this.size))) {
          console.warn(`Invalid size value: ${this.size}. Falling back to default size '1.5rem'.`)
          return '1.5rem';
        }
        return `${this.size}px`;
    }
  }

  render() {
    return html`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="${this._size}" height="${this._size}" fill="${this.color}"><path d="M12 1.25A8.75 8.75 0 0 1 20.75 10c0 2.75-1.51 5.464-3.155 7.624-1.662 2.183-3.555 3.923-4.504 4.742l-.04.032a1.75 1.75 0 0 1-.91.346L12 22.75a1.75 1.75 0 0 1-1.052-.352q-.02-.014-.039-.032c-.949-.82-2.842-2.559-4.504-4.742C4.761 15.464 3.25 12.749 3.25 10A8.75 8.75 0 0 1 12 1.25m0 1.5A7.25 7.25 0 0 0 4.75 10c0 2.244 1.259 4.627 2.849 6.716 1.553 2.04 3.335 3.688 4.256 4.486q.066.046.145.048l.08-.013a.3.3 0 0 0 .064-.035c.92-.798 2.704-2.445 4.257-4.486 1.59-2.09 2.849-4.472 2.849-6.716a7.25 7.25 0 0 0-6.89-7.241zm0 3.5a3.75 3.75 0 1 1 0 7.5 3.75 3.75 0 0 1 0-7.5m0 1.5a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5"/></svg>
    `;
  }
      
  static styles = css`
    :host {
      display: flex;
      max-height: min-content;
      max-width: min-content;
    }
  `;
  }
